// src/components/BotonFormulario.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "../style/BotonFormulario.css";

const BotonFormulario = ({ label = "PEDÍ PRESUPUESTO", size = "small", id }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/button-form");
  };

  return (
    <button
      id={id} // opcional, para casos donde necesites un id específico
      className={`boton-formulario ${size}`}
      onClick={handleClick}
    >
      {label}
    </button>
  );
};

export default BotonFormulario;
